import { ADD_WORK_INSTRUCTION, NULL_ERRORS, RECEIVE_WI_ERRORS } from '../actions/wi_actions'

const _nullErrors = [];

const WIErrorsReducer = (state = _nullErrors, action) => {
    Object.freeze(state);
    switch (action.type) {
        case RECEIVE_WI_ERRORS:
            return action.errors;
        case ADD_WORK_INSTRUCTION:
            return _nullErrors;
        case NULL_ERRORS:
            return _nullErrors;
        default:
            return state;
    }
};

export default WIErrorsReducer;